import React from 'react';
import { workProcess } from '../data/mockData';
import { motion } from 'framer-motion';

const HowWeWorkSection = () => (
  <section id="process" className="py-24 md:py-32 bg-white border-b-2 border-stone-200 overflow-hidden">
    <div className="max-w-7xl mx-auto px-6 lg:px-8">
      <motion.div initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, margin: "-80px" }} transition={{ duration: 0.6 }} className="text-center max-w-2xl mx-auto mb-20">
        <span className="text-xs font-bold uppercase tracking-[0.2em] text-orange-600 block mb-4">The Process</span>
        <h2 className="font-serif text-4xl sm:text-5xl tracking-tight text-stone-900 mb-4">Three Steps.<br/><span className="italic text-emerald-900">One Registered Trademark.</span></h2>
        <p className="text-stone-500 leading-relaxed">We keep it simple. You talk, we work, your brand gets protected.</p>
      </motion.div>
      <div className="grid md:grid-cols-3 gap-6">
        {workProcess.map((step, i) => (
          <motion.div key={step.id} initial={{ opacity: 0, y: 50 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, margin: "-50px" }} transition={{ duration: 0.6, delay: i * 0.15 }}
            className="group relative bg-stone-50 p-10 border-2 border-stone-200 transition-all duration-200 hover:border-stone-900 hover:-translate-y-2 hover:shadow-[8px_8px_0px_#1C1917]">
            <span className="font-serif text-[7rem] font-bold text-stone-100 absolute -top-2 right-4 leading-none select-none group-hover:text-emerald-100 transition-colors duration-300">{step.step}</span>
            <div className="relative z-10">
              <div className="w-10 h-10 bg-emerald-900 text-white text-sm font-bold flex items-center justify-center mb-6 border-2 border-emerald-900">{step.step}</div>
              <h3 className="font-sans text-xl font-bold text-stone-900 mb-3 group-hover:text-emerald-900 transition-colors">{step.title}</h3>
              <p className="text-sm text-stone-500 leading-relaxed">{step.description}</p>
            </div>
          </motion.div>
        ))}
      </div>
    </div>
  </section>
);
export default HowWeWorkSection;
